const ChevronLeftDouble = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
        <path d="M25.516 17.677 22.544 15 14 24.485l8.544 9.486 2.972-2.677-6.131-6.808 6.131-6.81Z" />
        <path d="M34.516 17.677 31.544 15 23 24.485l8.544 9.486 2.972-2.677-6.131-6.808 6.131-6.81Z" />
    </svg>
);

export default ChevronLeftDouble;
